module.exports = __webpack_public_path__ + "static/media/casagiardino.ff4198f4.png";